<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Etapa"
            @click.stop="confirmarDesassociar(pagamentoEtapa.pagamentoEtapaId)"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoEtapa: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociar(pagamentoEtapaId) {
            this.$swal({
                title: 'Desassociação de Etapa',
                html: `Confirma a desassociação da etapa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociar(pagamentoEtapaId)
                }
            })
        },

        desassociar(pagamentoEtapaId) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .desassociarEtapa({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoEtapaId: pagamentoEtapaId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro salvo com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar etapa do pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
